import { ArticleLayout } from "types/api";
import { ArticleRenderNotSupported } from "./error";

export default function checkArticleRenderSupport({
  article: { layout, isTnfCompatible },
}: {
  article: { layout: ArticleLayout; isTnfCompatible: boolean };
}) {
  if (layout === "feature" || !isTnfCompatible) {
    if (process.env.ENABLE_FEATURE_ARTICLE_RENDER !== "true") {
      // In prod, return error; otherwise log a warning
      throw new ArticleRenderNotSupported();
    } else {
      console.warn("Attempting to render an article that may not be supported");
    }
  }
}
